export enum Icons {
  assetsTree = 'assetsTree',
}
